export const CLIENT_CONFIG = {
  apiEndpoint: '/api/tracking/user-activity',
  sessionTimeout: 5000,
  heartbeatInterval: 30000,
  // debug: process.env.NODE_ENV === 'development',
  debug: false,
  isEventBatching: true,
};
